import { useI18n } from 'context/i18n';
import { useIsMounted, useLocale } from 'hooks';
import { useEffect, useState } from 'react';
import { Select } from 'antd';
import { ChevronSVG } from 'components/iconsSVG/chevron';
import styles from 'styles/CustomerService.module.css';
import { getGlobalReturnMethods } from 'actions/general';

export function ReturnCostsFaq() {
  const { locale, country: currentCountry } = useLocale();
  const { t, countries, profileData: { global_e } } = useI18n();
  const isMounted = useIsMounted();
  const [ selectedCountry, setSelectedCountry ] = useState(() => currentCountry);
  const [ returnMethods, setReturnMethods ] = useState([]);

  useEffect(() => {
    getGlobalReturnMethods(locale, selectedCountry).then((r) => {
      if (isMounted()) {
        setReturnMethods(r);
      }
    }).catch((error) => {
      console.error(error);
    });
  }, [ selectedCountry ]);

  return (
    <div>
      <div className={styles.selectGroup}>
        <Select
          placeholder={t('faqs', 'select.country', 'Select a country')}
          allowClear={false}
          filterOption={false}
          suffixIcon ={<ChevronSVG />}
          onChange={(val) => {
            setSelectedCountry(val);
          }}
          value={selectedCountry}
          className={styles.modalSelect}
          disabled={global_e}
        >
          {countries.map((country) => (
            <Select.Option key={country.id} className={styles.selectItem}>
              <p>{country.name}</p>
            </Select.Option>
          ))}
        </Select>
      </div>
      <div className={styles.shippingMethods}>
        {returnMethods.map((method, idx1) => (
          <div key={`method-${idx1}`}>
            <div className={styles.shippingTitle}>
              <div className={styles.shippingName}>{method.name}</div>
              <div className={styles.shippingPrice}>{method.priceFormatted}</div>
            </div>
            {Array.isArray(method.infoList) && method.infoList.length > 0 ? (
              <div className={styles.shippingInfoList}>
                {method.infoList?.map((info, idx2) => (
                  <div key={`method-info-${idx2}`} dangerouslySetInnerHTML={{ __html: `- ${info}` }} />
                ))}
              </div>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
}
